<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import GrvService from '../../../../domain/grv/services'
  import {isArray, debounce} from 'lodash'
  import moment from 'moment'
  import PatioService from '../../../../domain/patio/services/patio'
  import TransferenciaService from '../../../../domain/transferencia/services'
import { getPatiosPorTipo, GRV_ESPIRITO_SANTO } from '../../../../domain/grv/helpers/tipos-grv'

  export default {
    nome: 'transferencia-patio',
    directives: {mask},
    data () {
      return {
        isLoaded: false,
        extraModel: {
          dataSaida: null,
          horaSaida: null,
          dataChegada: null,
          horaChegada: null
        },
        data: {
          id: null,
          grv: null,
          dataChegada: null,
          dataSaida: null,
          patioOrigem: null,
          patioDestino: null,
          observacao: null
        },
        grv: {
          id: null,
          placa: null,
          numero: null
        },
        tipoProcesso: null,
        patios: [],
        edit: false,
        user: null,
        isLoading: false,
        cadastroError: null,
        atualizadoSucesso: null,
        listaGrvs: [],
        filtroInput: {
          id: null,
          titulo: ''
        },
        showOptionsAutocomplete: false,
        loading: false
      }
    },
    computed: {
      setSelectGrv () {
        console.log('toma')
        if (this.grv.id !== null) {
          return {label: `${this.grv.numero} - ${this.grv.placa}`, value: this.grv.id}
        } else {
          return null
        }
      },
      grvComputed () {
        return this.listaGrvs.map((v) => {
          let placa = v.tipoProcesso === 1 ? v.placaOriginal : v.placa
          return {label: `${v.numero} - ${placa}`, value: v.id}
        })
      },
      patiosDestino () {
        console.log(this.patios)
        var patiosTp = getPatiosPorTipo(this.tipoProcesso)
        let patios = this.patios.map((v) => {
          if (patiosTp.includes(v.id)) return v
        })
        if (this.tipoProcesso === GRV_ESPIRITO_SANTO) {
          patios.push(this.patios[5])// patio_central_detran_es
        }
        return patios.filter(p => typeof p !== 'undefined')
      }
    },
    mounted () {
      this.$loaderOverlay.open().message('Carregando dados relacionados')
      PatioService.list(10000, 1, '')
        .then(result => {
          this.patios = result.data.result
          this.$loaderOverlay.hide()
          this.isLoaded = true
          this.start()
        })
        .catch(error => {
          console.log(error)
          alert('Erro ao carregar lista de pátios')
        })
    },
    methods: {
      carregarGrv () {
        var id = this.data.grv
        this.$loaderOverlay.open().message('Carregando Grv')
        GrvService.find(id, false)
        .then((response) => {
          this.data.patioOrigem = response.data.patio.id
          this.tipoProcesso = response.data.tipoProcesso
        })
        .then(() => {
          this.$loaderOverlay.hide()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
      },
      selectedGrv (e) {
        if (e !== null) {
          this.data.grv = e.value
          var grvSelect = this.listaGrvs.find(r => r.id === e.value)
          let placa = grvSelect.tipoProcesso === 1 ? grvSelect.placaOriginal : grvSelect.placa
          this.grv.id = grvSelect.id
          this.grv.placa = placa
          this.grv.numero = grvSelect.numero

          this.carregarGrv()
        }
      },
      start () {
        if (this.$route.params.id && this.$route.params.id !== 'registrar') {
          this.edit = true
          this.$loaderOverlay.open().message('Carregando GRV')

          TransferenciaService.find(this.$route.params.id)
            .then((response) => {
              this.$loaderOverlay.hide()
              let data = response.data
              this.tipoProcesso = data.grv.tipoProcesso
              data.patioOrigem = data.patioOrigem.id
              data.patioDestino = data.patioDestino.id

              this.grv = data.grv
              data.grv = data.grv.id
              this.user = data.usuario ? data.usuario.pessoa.nome : null
              let dataChegada = JSON.parse(JSON.stringify(data.dataChegada))
              this.extraModel.dataChegada = moment(dataChegada.date).format('L')
              this.extraModel.horaChegada = moment(dataChegada.date).format('LT')
              let dataSaida = JSON.parse(JSON.stringify(data.dataSaida))
              this.extraModel.dataSaida = moment(dataSaida.date).format('L')
              this.extraModel.horaSaida = moment(dataSaida.date).format('LT')

              this.data = data

              console.log(response)
            })
            .catch((response) => {
              this.$loaderOverlay.hide()
              console.log(response)
            })
        } else {
        }
      },
      submit () {
        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando transferência...')
        }, 1000)
        let data = JSON.parse(JSON.stringify(this.data))
        data.dataChegada = this.extraModel.dataChegada + ' ' + this.extraModel.horaChegada
        data.dataSaida = this.extraModel.dataSaida + ' ' + this.extraModel.horaSaida
        TransferenciaService.cadastrar(data, this.$route.params.id).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
              this.start()
              this.atualizadoSucesso = true
              this.$el.querySelector('#sucessMsg').focus()
              // })
            } else {
              // Redirecionar para tela de visualização da grv criada
              this.$router.push({name: 'transferencia-patio'})
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      getListaGrvs: debounce(function (search, loading) {
        this.listaGrvs = []
        this.loading = true
        const filtro = search.split(' - ')[0]
        if (filtro) {
          GrvService.listaSimples(search, this.patio)
            .then(result => {
              this.listaGrvs = result.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
              alert('Erro ao carregar lista de grvs')
              this.loading = false
            })
        } else {
          this.loading = false
        }
      }, 300)
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="isLoaded">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">
            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Transferência de Pátio
                  </h1>
                </div>
              </div>
            </div>
          </div>

          <div class="panel panel-default">
            <div class="clearfix">
              <div>
                <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">

                  <div class="wrapper">
                    <div class="panel-body">
                      <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                        <div class="m-b-sm font-bold">Erro ao registrar a GRV, corrija e tente novamente</div>
                        <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                      </div>
                      <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
                      <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null" class="alert alert-success">
                        <div class="font-bold">Atualizado com sucesso!</div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light"
                           style="border-top: 1px solid #eaeff0;">
                      <thead>
                      <tr>
                        <th>GRV</th>
                        <th>Data de saída</th>
                        <th>Pátio de origem</th>
                        <th>Pátio de destino</th>
                        <th>Data de chegada</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td scope="row">
                            <label style="width: 200px">GRV</label>
                            <div>
                              <v-select :options="grvComputed" @search="getListaGrvs" placeholder="Selecione uma grv" ref="selectGrvRef" :value="setSelectGrv" @input="selectedGrv" :filterable="false" :disabled="edit"></v-select>
                            </div>
                        </td>
                        <td scope="row">
                          <label>Data:</label>
                          <div>
                            <input required id="dataSaida" placeholder="dd/mm/yyyy"
                                   v-model="extraModel.dataSaida"
                                   v-mask="'##/##/####'" type="text" class="form-control"/>
                          </div>

                          <label>Hora:</label>
                          <div>
                            <input required id="horaSaida" placeholder="00:00"
                                   v-model="extraModel.horaSaida"
                                   v-mask="'##:##'" type="time" class="form-control"/>
                          </div>
                        </td>
                        <td scope="row">
                          <select class="form-control" v-model="data.patioOrigem" required disabled>
                            <option :value="null" disabled>Selecione</option>
                            <option :value="patio.id" v-for="patio in patios" :key="patio.id">{{patio.nome}}</option>
                          </select>
                        </td>
                        <td scope="row">
                          <select class="form-control" v-model="data.patioDestino" required>
                            <option :value="null" disabled>Selecione</option>
                            <option :value="patio.id" v-for="patio in patiosDestino" :key="patio.id">{{patio.nome}}</option>
                          </select>
                        </td>
                        <td scope="row">
                          <label>Data:</label>
                          <div>
                            <input required id="dataChegada" placeholder="dd/mm/yyyy"
                                   v-model="extraModel.dataChegada"
                                   v-mask="'##/##/####'" type="text" class="form-control"/>
                          </div>

                          <label>Hora:</label>
                          <div>
                            <input required id="horaChegada" placeholder="00:00"
                                   v-model="extraModel.horaChegada"
                                   v-mask="'##:##'" type="time" class="form-control"/>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!---->
                  <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h2 class="font-thin h3">
                          Observações
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="form-group">
                        <label for="observacao" class="col-sm-2 control-label">Observações</label>
                        <div class="col-sm-4">
                          <textarea id="observacao" v-model="data.observacao" rows="7" class="form-control"
                                    style="resize: none;"></textarea>
                        </div>
                        <label v-if="user" class="col-sm-2 control-label">Usuário Responsável</label>
                        <div class="col-sm-4">
                          <input v-if="user" type="text" class="form-control" :value="user" disabled>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="wrapper">
                    <div class="panel-body">
                      <div class="row">
                        <button class="btn btn-success btn-md m-l-xs btn-colsultaGrv">Salvar</button>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .form-grv label {
    cursor: pointer;
  }

  .btn-colsultaGrv {
    padding-top: 7px;
    padding-bottom: 7px;
  }

  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 100%;
    height: 100%;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 100%;
    max-height: 80px;
    overflow: auto;
    background-color: #fff;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// Transferencia.vue?153e3743